import React from 'react';

import { Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { Status, StatusText } from 'app/zap-templates/types';

const headers = {
  [Status.draft]:
    'Draft Zap templates are visible only to you. Once you’ve finished setting up your Zap template, you can submit it to be reviewed by selecting "For Review" in the Zap template creator.',
  [Status.forReview]: (
    <span>
      Zap templates that are in review are only visible to you and those you
      share your Zap template link with. Zap template review typically takes 1-2
      weeks.
    </span>
  ),
  [Status.rejected]:
    'Rejected Zap templates can be edited and you can share the link to the Zap template with others. Please refer to the email from Zapier to make updates and re-submit for review.',
  [Status.published]: (
    <span>
      Public Zap templates are visible on Zapier.com, in our Embed Widget and
      available via our Workflow API. You can't edit Public Zap templates so
      contact <Link href="mailto:partners@zapier.com">partners@zapier.com</Link>{' '}
      for help.
    </span>
  ),
};

type Props = {
  status: Status | undefined;
};

function Header({ status }: Props) {
  return (
    <div>
      <Text margin="0 0 10px" tag="p" type="PageHeader">
        Zap templates:{' '}
        <span style={{ textTransform: 'capitalize' }}>
          {status
            ? Status.community === status
              ? 'Shared'
              : StatusText[status]
            : 'Partner'}
        </span>
      </Text>
      <Text tag="p" type="Body1">
        {status
          ? headers[status]
          : 'Zap templates are preconfigured workflows that you set up to make it easy for Zapier users to use your app.'}
      </Text>
    </div>
  );
}

export default Header;
